var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16998 0.040006L1.16998 1.36999C0.489983 1.51999 0 2.12998 0 2.82998V15.17C0 15.87 0.489983 16.48 1.16998 16.63L7.16998 17.96C8.10998 18.17 9 17.46 9 16.5V1.5C9 0.539998 8.10998 -0.169994 7.16998 0.040006ZM5.52002 10C4.97002 10 4.52002 9.55 4.52002 9C4.52002 8.45 4.96001 8 5.51001 8H5.52002C6.07002 8 6.52002 8.45 6.52002 9C6.52002 9.55 6.07002 10 5.52002 10ZM11 15.7V2.29999C11 2.13399 11.134 2 11.3 2H12.5C13.328 2 14 2.672 14 3.5V14.5C14 15.328 13.328 16 12.5 16H11.3C11.134 16 11 15.866 11 15.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d83f26c5f721cf7ffc2b990a5e05b61a.svg";
export { ForwardRef as ReactComponent };